/* eslint-disable no-console */

import { register } from 'register-service-worker';
import { urlBase64ToUint8Array } from './utils/helpers';

let getVersionPort = null;

// Listen for install event, this happens when the service worker is first installed
self.addEventListener('install', function (event) {
  event.waitUntil(self.skipWaiting()); // Activate worker immediately
});

// Listen for activate event, which only happens when the worker is first activated
self.addEventListener('activate', function (event) {
  event.waitUntil(self.clients.claim()); // Become available to all pages
});

self.addEventListener('message', async function (event) {
  if (event.data && event.data.type === 'INIT_PORT') {
    getVersionPort = event.ports[0];
  }
  if (event.data && event.data.type === 'SW_INIT_WEB_PUSH_NOTIFICATION') {
    await registerPushNotification(
      self.registration,
      event.data.payload.publicKey
    );
  }
});

// listen to push notification event
self.addEventListener('push', (e) => {
  console.log('sw> Received a push message', e);
  const data = e.data.json();
  console.log('sw> Data', data);
  if (Notification.permission === 'granted') {
    const options = {
      body: data.message,
      icon: data.icon,
      badge: data.badge,
      vibrate: [100, 50, 100],
      data: {
        dateOfArrival: Date.now(),
        primaryKey: 1,
      },
    };
    e.waitUntil(self.registration.showNotification(data.title, options));
  }
});

// if (process.env.NODE_ENV === "production") {

/**
 * Register subscription for push notifications
 */
const registerPushNotification = async (register, publicKey) => {
  console.log('sw> Registering push notification');
  const pushSubscription = await register.pushManager.getSubscription();
  if (pushSubscription) {
    return;
  }

  try {
    // Parse public key
    const applicationServerKey = urlBase64ToUint8Array(publicKey);

    // Subscribe to push
    let subscription = undefined;

    subscription = await register.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey,
    });

    // Parse subscription object
    const subscriptionData = subscription.toJSON();
    const key = subscriptionData.keys.p256dh;
    const token = subscriptionData.keys.auth;
    const request = {
      endpoint: subscription.endpoint,
      userPublicKey: btoa(
        String.fromCharCode.apply(null, new urlBase64ToUint8Array(key))
      ),
      userAuthToken: btoa(
        String.fromCharCode.apply(null, new urlBase64ToUint8Array(token))
      ),
    };

    const requestParams = {
      endpoint: request.endpoint,
      p256dh: btoa(
        String.fromCharCode.apply(
          null,
          new urlBase64ToUint8Array(request.userPublicKey)
        )
      ),
      auth: btoa(
        String.fromCharCode.apply(
          null,
          new urlBase64ToUint8Array(request.userAuthToken)
        )
      ),
    };

    getVersionPort.postMessage({
      type: 'SUBSCRIBE',
      payload: JSON.stringify(requestParams),
    });
  } catch (error) {
    if (Notification.permission === 'denied') {
      // The user denied the notification permission which
      // means we failed to subscribe and the user will need
      // to manually change the notification permission to
      // subscribe to push messages
      console.warn('sw> Permission for Notifications was denied');
    } else {
      // A problem occurred with the subscription; common reasons
      // include network errors, and lacking gcm_sender_id and/or
      // gcm_user_visible_only in the manifest.
      console.error('sw> Unable to subscribe to push.', error);
    }
  }
};

register(`${process.env.BASE_URL}sw.js`, {
  async ready() {
    console.log('sw> App is being served from cache by a service worker.');
    await self.Notification.requestPermission();
  },
  registered() {
    console.log('sw> Service worker has been registered.');
  },
  cached() {
    console.log('Content has been cached for offline use.');
  },
  updatefound() {
    console.log('New content is downloading.');
  },
  updated() {
    console.log('New content is available; please refresh.');
  },
  offline() {
    console.log(
      'No internet connection found. App is running in offline mode.'
    );
  },
  error(error) {
    console.error('Error during service worker registration:', error);
  },
});
// }
